/** Image `src` points at the server's media route, never at S3 directly. */
export const BUSINESS_UPDATE_MEDIA_PATH = '/v2/business/updates/media';
export const BUSINESS_UPDATE_MEDIA_KEY_PREFIX = 'business-updates/';
export const buildBusinessUpdateMediaUrl = (apiBaseUrl, key) => `${apiBaseUrl.replace(/\/+$/, '')}${BUSINESS_UPDATE_MEDIA_PATH}?key=${encodeURIComponent(key)}`;
export const isBusinessUpdateMediaUrl = (src) => {
    try {
        const url = new URL(src);
        return (url.pathname === BUSINESS_UPDATE_MEDIA_PATH &&
            (url.searchParams.get('key') ?? '').startsWith(BUSINESS_UPDATE_MEDIA_KEY_PREFIX));
    }
    catch {
        return false;
    }
};
//# sourceMappingURL=businessUpdateMedia.js.map